import ModalComponent from '../../../../components/ModalComponent';
import { Controller, useForm } from 'react-hook-form';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import zod from 'zod';
import { RoleFormSchema } from '../../../../services/RoleService/schemas';
import { zodResolver } from '@hookform/resolvers/zod';
import { Grid2 } from '@mui/material';
import ButtonComponent from '../../../../components/ButtonComponent';
import PermissionsMultiselect from './PermissionsMultiselect';
import {
  useCreateRoleAsync,
  useUpdateRoleAsync,
} from '../../../../services/RoleService/hooks/useMutation';
import { useContext, useEffect } from 'react';
import { AppContext } from '../../../../context/AppContextProvider';

type RoleEditionFormInput = zod.infer<typeof RoleFormSchema>;

interface RoleEditionModalProps {
  isOpen: boolean;
  roleToEdit?: any;
  setIsOpen: (isOpen: boolean) => void;
  handleSaveForm: () => void;
}

const RoleEditionModal = ({
  isOpen,
  setIsOpen,
  roleToEdit,
  handleSaveForm,
}: RoleEditionModalProps) => {
  const { showSnackbar } = useContext(AppContext);
  const { control, handleSubmit, reset, watch } = useForm<RoleEditionFormInput>(
    {
      resolver: zodResolver(RoleFormSchema),
      defaultValues: {
        name: '',
        hexadecimalColor: '#0047ff',
        permissions: [],
      },
    },
  );

  const { mutate: mutateCreateRoleAsync, isLoading: isLoadingCreateRole } =
    useCreateRoleAsync();
  const { mutate: mutateUpdateRoleAsync, isLoading: isLoadingUpdateRole } =
    useUpdateRoleAsync();

  const handleSave = (data: RoleEditionFormInput) => {
    if (data?.id) {
      mutateUpdateRoleAsync(
        { id: data.id, data },
        {
          onSuccess: () => resetAndShowMessage('Cargo atualizado com sucesso.'),
        },
      );
      return;
    }
    mutateCreateRoleAsync(data, {
      onSuccess: () => {
        resetAndShowMessage('Cargo criado com sucesso.');
      },
    });
  };

  const resetAndShowMessage = (message: string) => {
    showSnackbar(message, 'success');
    reset();
    setIsOpen(false);
    handleSaveForm();
  };

  const handleClose = () => {
    setIsOpen(false);
    reset();
  };

  const permissionsWatch = watch('permissions');

  // useEffect(() => {
  //   if (permissionsWatch) {
  //     permissionsWatch.forEach((p) => {
  //       permissionsWatch[p]
  //     });
  //   }
  // }, [permissionsWatch]);

  useEffect(() => {
    if (roleToEdit) reset(roleToEdit, { keepDefaultValues: true });
  }, [roleToEdit]);

  return (
    <ModalComponent
      title={'Edição do cargo'}
      isOpen={isOpen}
      onClose={handleClose}
    >
      <Grid2 container columnSpacing={3}>
        <Grid2 size={6}>
          <Controller
            render={({ field: { value, onChange } }) => (
              <TextFieldComponent
                label="Nome"
                value={value}
                onChangeText={onChange}
              />
            )}
            name={'name'}
            control={control}
          />
        </Grid2>
        <Grid2 size={6}>
          <Controller
            render={({ field: { value, onChange } }) => (
              <TextFieldComponent
                label="Cor representativa"
                value={value}
                type="color"
                onChangeText={onChange}
              />
            )}
            name={'hexadecimalColor'}
            control={control}
          />
        </Grid2>
        <Grid2 size={12}>
          <Controller
            render={({ field: { value, onChange } }) => (
              <PermissionsMultiselect onChange={onChange} value={value} />
            )}
            name={'permissions'}
            control={control}
          />
        </Grid2>
        <Grid2 size={12}>
          <ButtonComponent
            fullWidth
            onClick={handleSubmit(handleSave)}
            loading={isLoadingCreateRole || isLoadingUpdateRole}
          >
            Salvar
          </ButtonComponent>
        </Grid2>
      </Grid2>
    </ModalComponent>
  );
};

export default RoleEditionModal;
